import { jsx as _jsx } from "react/jsx-runtime";
import { Card } from 'antd';
import UIComponent from './uiComponent';
import UIText from './uiText';
import Meta from 'antd/es/card/Meta';
import { makeStyles } from '@fluentui/react-components';
const useStyles = makeStyles({
    root: {
        '& .ant-card-body': {
            paddingTop: '0px',
            paddingBottom: '0px',
        },
    },
});
function UIImageHeaderComponent(props) {
    const styles = useStyles();
    const style = {
        width: 400,
        marginTop: '20px',
        marginBottom: '20px',
        borderRadius: '8px',
        border: '2px solid #ff5c35',
        marginLeft: 'auto',
        marginRight: 'auto',
    };
    return (_jsx("div", { children: _jsx(Card, { style: style, className: styles.root, cover: _jsx("img", { alt: "example", src: props.image }), children: _jsx(Meta, { title: props.text }) }) }));
}
export default class UIImageHeader extends UIComponent {
    image;
    text;
    constructor(s) {
        super(s);
        this.image = this.getProperty('image');
        if ('text' in s) {
            this.text = new UIText(s);
        }
    }
    getComponent() {
        const text = this.text !== undefined ? this.text.getComponent() : null;
        const props = {
            image: this.image,
            text: text,
        };
        return _jsx(UIImageHeaderComponent, { ...props });
    }
}
//# sourceMappingURL=uiImageHeader.js.map